export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-16.c32d9f87.png";